import { Flex } from '../../../../layout/Flex';
import type { ContentPromotionPostsDialogListProps } from './types';

export const ContentPromotionPostsDialogList: React.FC<ContentPromotionPostsDialogListProps> = ({
    count,
    renderItem,
}) => {
    const content = [];

    for (let i = 0; i < count; i++) {
        content.push(renderItem(i));
    }

    return <Flex width="100%">{content}</Flex>;
};
